import { PostType } from "@ascendnow/shared";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

export function formatTime(date: string) {
  const isToday = dayjs().isSame(date, "day");
  const isThisYear = dayjs().isSame(date, "year");

  if (isToday) {
    return dayjs(date).format("h:mm A");
  } else if (isThisYear) {
    return dayjs(date).format("h:mm A, MMM D");
  } else {
    return dayjs(date).format("MMM D, YYYY");
  }
}

export function getPostTypeColor(type: PostType) {
  switch (type) {
    case "CONTENT":
      return "card-brand-orange";
    case "GENERAL":
      return "card-light-green-inverted";
    case "PLATFORM":
      return "card-brand-red";
    case "WEBINARS":
      return "card-purple";
    case "COMPETITIONS":
    default:
      return "card-light-green";
  }
}
